<template>
    <div class="c-t-default">
        <site-header></site-header>
        <my-pages-company v-if="isCompany" :isCompany="isCompany"></my-pages-company>
        <my-pages-customer v-else-if="isCustomer" :isCustomer="isCustomer"></my-pages-customer>
        <site-footer></site-footer>
    </div>
</template>
<script>

    import { mapGetters, mapActions } from 'vuex';

    import { FETCH_COMPANY_USER_BY_ID, FETCH_COMPANY_REQUESTS, GET_COMPANY_MAIL_TEMPLATES } from '../store/store-models/my-pages-company-model';
    import { FETCH_CUSTOMER_BY_ID } from '../store/store-models/my-pages-customer-model';
    import { IS_CUSTOMER, IS_COMPANY, GET_USER, LOG_OUT } from '../store/store-models/authentication-model'
    import { FETCH_SEARCH_PROFILE } from '../store/store-models/search-profile-model';
    import { FETCH_REQUEST_IDS_WITH_CONTRACT } from '../store/store-models/contract-model'

    import SiteHeader from './components/organisms/OrganismSiteHeader.vue';
    import SiteFooter from './components/organisms/OrganismSiteFooter.vue';
    import MyPagesCustomer from './MyPagesCustomer.vue';
    import MyPagesCompany from './MyPagesCompany.vue';

    export default {
        components:{
            SiteHeader,
            SiteFooter,
            MyPagesCustomer,
            MyPagesCompany
        },
        computed: {
            ...mapGetters({
                isCustomer: IS_CUSTOMER,
                isCompany: IS_COMPANY,
                getUser: GET_USER
            })
        },
        methods: {
            ...mapActions({
                fetchCompanyUserById: FETCH_COMPANY_USER_BY_ID,
                fetchCompanyRequests: FETCH_COMPANY_REQUESTS,
                fetchSearchProfile: FETCH_SEARCH_PROFILE,
                fetchCustomerById: FETCH_CUSTOMER_BY_ID,
                getCompanyMailTemplates: GET_COMPANY_MAIL_TEMPLATES,
                logOut: LOG_OUT,
                fetchRequestIdsWithContract: FETCH_REQUEST_IDS_WITH_CONTRACT
            }),
            async handleLogOut() {
                await this.logOut();
                this.$router.push({name: 'Logga in'});
            }
        },
        created() {

            if (this.isCompany) {
                this.fetchCompanyUserById();
                this.fetchCompanyRequests();
                this.fetchSearchProfile();
            } else if (this.isCustomer ) {
                this.fetchCustomerById();
            }
            this.fetchRequestIdsWithContract();
        },
          metaData() {
            return {
                link: [
                {
                    rel: "canonical",
                    href: `${process.env.SITE_BASE_URL}${this.$route.path}`
                }
                ]
            };
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/MyPages.vue